import * as yup from 'yup';

const passwordValidator = yup
  .string()
  .min(10)
  .max(100)
  .test(
    '',
    'Password has contain at least 3 of the following: uppercase, lowercase, numeric or special characters',
    (value) => {
      const marked = {
        uppercase: false,
        lowercase: false,
        numeric: false,
        special: false,
      };
      (value || '')?.split('').forEach((val) => {
        if (/[A-Z]/.test(val)) {
          marked.uppercase = true;
        } else if (/[a-z]/.test(val)) {
          marked.lowercase = true;
        } else if (/[0-9]/.test(val)) {
          marked.numeric = true;
        } else if (/[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]/.test(val)) {
          marked.special = true;
        }
      });
      return marked.uppercase && marked.lowercase && (marked.numeric || marked.special)
    },
  )
  .required('Required');

export { passwordValidator };